import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Create,
	Show,
	trans
} from '@/router/index'

import Vue from 'vue'
import CalendarEdit from '@/components/modules/calendar/CalendarEdit'
import YelloCalendar from '@/components/modules/calendar/YelloCalendar'
import CalendarOptions from '@/components/modules/calendar/settings/CalendarOptions'

export const calendar = [
	{
		path: '/calendar',
		name: 'calendar',
		meta: {
			title: trans('calendar')
		},
		beforeEnter: ifAuthenticatedOnline,
		component: YelloCalendar,
		props: {
			modelDef: 'calendar',
			actionIcon: 'event',
			title: 'Calendario'
		}
	},
	{
		path: '/profile/calendar/create',
		name: 'calendars-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'calendars',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/profile/calendars/:id/edit',
		name: 'calendars-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: CalendarEdit,
		props: (route) => ({
			modelDef: 'calendars',
			id: parseInt(route.params.id),
			actionIcon: 'event',
			title: 'Calendario',
			redirect: {modelDef: 'calendars-show', id: parseInt(route.params.id)}
		}),
	},
	{ 
		path: '/profile/calendars/:id',
		name: 'calendars-show', 
		beforeEnter: ifAuthenticatedOnline,
		component: Show,
		props: (route) => ({
			id: parseInt(route.params.id),
			modelDef: 'calendars',
			modelClass: 'calendar',
			activities: true,
			fileuploader: false,
			maillogs: false
		}), 
	},
    {
		path: '/settingscalendar/',
		name: 'settingscalendar',
		component: AppTabs,
		props: {
			tabs: [
				{				
					to: '/settingscalendar/',
					text: 'Calendario',
				},
			],
		},
		children: [	
			{
				path: '/settingscalendar/',
				component: CalendarOptions,
			},
		]
	},	
]